const config = {
  steps: [
    { step: 10, title: "投稿" },
    { step: 20, title: "等待编辑审稿" },
    { step: 21, title: "等待作者改稿" },
    { step: 22, title: "等待编辑审稿" },
    { step: 30, title: "等待登记出版费" },
    { step: 35, title: "等待核对审稿费缴纳" },
    { step: 40, title: "等待支付出版费" },
    { step: 50, title: "等待专家审稿" },
    { step: 51, title: "等待作者改稿" },
    { step: 52, title: "等待专家审稿" },
    { step: 53, title: "等待上传著作权许可书" },
    { step: 60, title: "等待查重" },
    { step: 61, title: "等待作者改稿" },
    { step: 62, title: "等待编辑审稿" },
    { step: 63, title: "等待二次查重" },
    { step: 99, title: "完成" },
  ],

  //基本步骤（展示在投稿界面）
  stepBasic: [
    { name: "投稿", status: "wait" },
    { name: "编辑评审", status: "wait" },
    { name: "专家评审", status: "wait" },
    { name: "上传著作权许可书", status: "wait" },
    { name: "查重", status: "wait" },
    { name: "完成", status: "wait" },
  ],

  //基本步骤（展示在投稿界面，收费环节）
  stepCharge: [
    { name: "投稿", status: "wait" },
    { name: "编辑评审", status: "wait" },
    { name: "支付出版费", status: "wait" },
    { name: "专家评审", status: "wait" },
    { name: "上传著作权许可书", status: "wait" },
    { name: "填写发票信息", status: "wait" },
    { name: "查重", status: "wait" },
    { name: "完成", status: "wait" },
  ],

  //是否收出版费
  isCharge: true,

  //刊物信息
  infos:{
    xx:[
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
    ],
    zx:[
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
    ],
    dx:[
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
    ],

    dx2:[
      {title:"期刊级别",value:"省级期刊"},
      {title:"出版周期",value:"半月刊"},
      {title:"主管单位",value:"南宁师范大学"},
      {title:"期刊分类",value:"高等教育学"},
      {title:"主办单位",value:"南宁师范大学"},
      {title:"邮发代号",value:"48-21、48-24"},
      {title:"创刊时间",value:"2012"},
      {title:"ISSN",value:"2095-3437"},
      {title:"CN",value:"45-1387/G4"},
      {title:"期刊语言",value:"中文"},
      {title:"主编",value:"黎海英"},
      {title:"邮编",value:"530022"},
    ],

    cxzw:[
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
      {title:"",value:""},
    ]
  }
}

export default config
